import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Auth } from '../../shared/services/auth';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'Create-Roles-Permission',
  templateUrl: 'createRolesAndPermission.html',
})
export class CreateRolesAndPermissionComponent {
  public _baseUrl: any;
  public roleData: any = {};
  public selectedOperation: any = [];
  public type: any = 'CREATE';
  public buttonDisabled: any = false;
  public rolePayload: any = {
    id: null,
    code: null,
    name: null,
    description: null,
    operations: null
  };
  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public _http: HttpClientCustom,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public _toaster: ToasterComponent,
    public translate:TranslateService,
    vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get("EPMS_BASE_URL");
    this.roleData = this.share.getMapValues('roleData');
    this.type = this.share.getMapValues('type');
    
    if (_.isEmpty(this.roleData)) {
      this._location.back();
    } else {
      if (this.type == 'EDIT') {
        this.checkForSelectedRole();
      }
      this._toaster.setViewRef(vcr);
    }
  }

  selected(p) {
    let that = this;
    if (p.assigned) {
      that.selectedOperation.push(p.operation);
    } else {
      _.each(that.selectedOperation, function (key, val) {
        if (p.operation == key) {
          that.selectedOperation.splice(val, 1);
        }
      });
    }
  }

  checkForSelectedRole() {
    let that = this;
    _.each(that.roleData.operations, function (key, val) {
      if (key.assigned) {
        that.selectedOperation.push(key.operation);
      }
      if (key.childOperations.length > 0) {
        that.checkForSelectedChildRole(key.childOperations);
      }
    });
  }
  checkForSelectedChildRole(childOperations) {
    let that = this;
    _.each(childOperations, function (key, val) {
      if (key.assigned) {
        that.selectedOperation.push(key.operation);
      }
    });
  }

  getPayload() {
    let that = this;
    that.rolePayload.id = that.roleData.id;
    that.rolePayload.description = that.roleData.description;
    that.rolePayload.code = that.roleData.code;
    that.rolePayload.name = that.roleData.name;
    that.rolePayload.operations = that.selectedOperation;
    return that.rolePayload;

  }

  validateRoles() {
    let that = this;
    if (that.roleData.name == null) {
      this.translate.get('nameShouldNotEmpty').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
     
      return false;
    } else if (that.roleData.name.trim() == '') {
      this.translate.get('nameShouldNotEmpty').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
      return false;
    }
    if (that.roleData.code == null) {
      this.translate.get('codeShouldNotEmpty').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
      return false;
    } else if (that.roleData.code.trim() == '') {
      this.translate.get('codeShouldNotEmpty').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
      return false;
    }
    if (that.selectedOperation.length == 0) {
      this.translate.get('pleaseSelectOperation').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

  editOrSave() {
    try {
      let that = this;

      if (this.validateRoles()) {
        that.buttonDisabled = true;
        let url = that._baseUrl + 'v1/webAdmin/role';
        that._http.post(url, that.getPayload()).subscribe((result) => {
          that.buttonDisabled = false;
          if (result.success) {
            this.translate.get('savedRolesAndOperations').subscribe((msg)=>{
              this._toaster.showSuccess(msg);
            });
            setTimeout(() => { that._location.back(); }, 1000)
          } else {
            this.translate.get(result.errorMessage).subscribe((msg)=>{
              this._toaster.showError(msg);
            });
          }
        });
      }

      
    } catch (e) {
      console.log('editOrSave roles', e);
    }
  }

  rolesBack() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/createRolesAndPermission.ts